export default function () {
	const match =
		RegExp(/partners\/([0-9a-z-]+)/).exec(window.location.pathname) || [];
	return match[1];
}
